// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"5f4222a8","96":"8e389ea0","192":"b100851b","370":"78c64e1e","371":"49222921","453":"93b3d9fd","470":"7e40d94a","488":"7d374ba0","504":"36ef886a","749":"cdda2939","770":"52d8f137","777":"38a0d9a1","812":"b77b93bb"}[chunkId] + ".chunk.js";
};